module.exports = __webpack_public_path__ + "static/media/Preview_iOS.91b94875.png";